// Global theme configuration for PRSNL
// Off-white theme (#f5f3f0)

export const theme = {
  // Base colors
  bg: '#f5f3f0',
  card: '#ffffff',
  card2: '#f0ede8',
  
  // Borders
  border: '#e0dbd4',
  borderLight: '#ebe8e3',
  
  // Text
  text: '#1a1a1a',
  textMuted: 'rgba(26,26,26,0.58)',
  textLight: 'rgba(26,26,26,0.42)',
  textVeryLight: 'rgba(26,26,26,0.22)',
  
  // Brand colors
  orange: '#F05A1A',
  orangeDim: 'rgba(240,90,26,0.08)',
  orangeBorder: 'rgba(240,90,26,0.22)',
  orangeHover: '#D94D0F',
  
  // Status colors
  green: '#16a34a',
  greenBg: 'rgba(22,163,74,0.08)',
  greenBorder: 'rgba(22,163,74,0.2)',
  
  red: '#dc2626',
  redBg: 'rgba(220,38,38,0.08)',
  redBorder: 'rgba(220,38,38,0.15)',
  
  yellow: '#d97706',
  yellowBg: 'rgba(245,158,11,0.07)',
  yellowBorder: 'rgba(245,158,11,0.28)',
  
  // Input/Form colors
  inputBg: '#ffffff',
  inputBorder: '#e0dbd4',
  inputFocus: '#F05A1A',
  
  // Shadow
  shadow: '0 2px 12px rgba(0,0,0,0.04)',
  shadowMd: '0 4px 16px rgba(0,0,0,0.06)',
  shadowLg: '0 8px 32px rgba(0,0,0,0.08)',
};

// Dark theme variant (for backwards compatibility)
export const darkTheme = {
  bg: '#111111',
  card: '#1E1E1E',
  card2: '#2E2E2E',
  border: '#2E2E2E',
  borderLight: '#3E3E3E',
  text: '#ffffff',
  textMuted: '#AAAAAA',
  textLight: '#666666',
  textVeryLight: '#444444',
  orange: '#F05A1A',
  orangeDim: 'rgba(240,90,26,0.15)',
  orangeBorder: 'rgba(240,90,26,0.5)',
  orangeHover: '#D94D0F',
  green: '#22C55E',
  greenBg: 'rgba(34,197,94,0.15)',
  greenBorder: 'rgba(34,197,94,0.3)',
  red: '#EF4444',
  redBg: 'rgba(239,68,68,0.15)',
  redBorder: 'rgba(239,68,68,0.3)',
  yellow: '#F59E0B',
  yellowBg: 'rgba(245,158,11,0.15)',
  yellowBorder: 'rgba(245,158,11,0.3)',
  inputBg: '#1E1E1E',
  inputBorder: '#2E2E2E',
  inputFocus: '#F05A1A',
  shadow: '0 2px 12px rgba(0,0,0,0.3)',
  shadowMd: '0 4px 16px rgba(0,0,0,0.4)',
  shadowLg: '0 8px 32px rgba(0,0,0,0.5)',
};

export default theme;
